import request from '@/utils/request'
//学校界面整体数据查询接口
export function GetSchoolCha(data) {
  return request({
    url: '/html/school',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/schoolcha.js